import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "checklist/type-occurrence-status"

class service {

    selectList(params) {
        return http.list(path + "/selectList",params);
    }

    getAllCriticality() {
        let params = new URLSearchParams()
        params.set("status", "1")
        return http.list(path + "/selectAll",params);
    }


}

export default new service();

